import {ClassicPageContainer} from '@/components/PageContainer/ClassicPageContainer';
import {Outlet} from 'react-router-dom';

export default function ClassicLayout() {
  return (
    <ClassicPageContainer>
      <Outlet />
    </ClassicPageContainer>
  );
}
